module.exports = __webpack_public_path__ + "img/WTMS_sword3.0210c9dc.png";